import { TModalWindowProps } from '@libs/types';
import { Portal } from '@libs/utils';
import { styled } from '@mui/material/styles';
import React, { useEffect, useEffectEvent, useState } from 'react';
import { zIndex } from '../utils/constants';

const ModalContainer = styled('div')(({ theme }) => [
    {
        backgroundColor: theme.palette.common.white,
        bottom: 0,
        left: 0,
        minWidth: '288px',
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: zIndex.modalIndex,
    },
    theme.applyStyles('dark', {
        background: theme.palette.common.black,
    }),
]);
const ModalViewport = styled('div')(({ theme }) => [
    {
        backgroundColor: theme.palette.common.white,
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    theme.applyStyles('dark', {
        background: theme.palette.common.black,
    }),
]);
const ModalBody = styled('div')({
    padding: '72px 0 0 0',
    margin: '0 auto',
    maxWidth: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '@media screen and (min-width: 481px)': {
        maxWidth: '480px',
    },
    '@media screen and (min-width: 708px)': {
        padding: '104px 0',
        maxWidth: `calc(((100% - 168px) / 6) * 4 + 120px)`,
    },
    '@media screen and (min-width: 889px)': {
        maxWidth: '600px',
    },
});

export const ModalWindow = ({ WidgetsList, widgetId, modalWindows }: TModalWindowProps) => {
    const [id, setId] = useState<string>('');
    const currentModalWindow = modalWindows?.[id];

    const updateModal = useEffectEvent((wId?: string) => {
        if (wId) {
            setId(wId);
        }
    });

    useEffect(() => {
        updateModal(widgetId);
    }, [widgetId]);

    if (id && currentModalWindow) {
        return (
            <Portal>
                <ModalContainer id="portal-modal">
                    <ModalViewport>
                        <ModalBody>
                            <WidgetsList uids={currentModalWindow.uid} />
                        </ModalBody>
                    </ModalViewport>
                </ModalContainer>
            </Portal>
        );
    }
    return false;
};
